import { ReactComponent as Avatar } from '../../assets/avatar.svg';
import { ReactComponent as AvatarPhoto } from '../../assets/avatarPhoto.svg';
import { ReactComponent as Search } from '../../assets/search.svg';
import { ReactComponent as SuccessTick } from '../../assets/success_tick.svg';
import { ReactComponent as ErrorCircle } from '../../assets/error_circle.svg';
import { ReactComponent as AdminHomeFilled } from '../../assets/admin_home_filled.svg';
import { ReactComponent as AdminHomeOutline } from '../../assets/admin_home_outline.svg';
import { ReactComponent as AdminFilled } from '../../assets/admin_filled.svg';
import { ReactComponent as AdminWhite } from '../../assets/admin_white.svg';
import { ReactComponent as AdminOutline } from '../../assets/admin_outline.svg';
import { ReactComponent as StudentFilled } from '../../assets/student_filled.svg';
import { ReactComponent as StudentOutline } from '../../assets/student_outline.svg';
import { ReactComponent as StudentWhite } from '../../assets/student_white.svg';
import { ReactComponent as FeeSetupFilled } from '../../assets/fee_setup_filled.svg';
import { ReactComponent as FeeSetupOutline } from '../../assets/fee_setup_outline.svg';
import { ReactComponent as FeeSetupWhite } from '../../assets/fee_setup_white.svg';
import { ReactComponent as FeeCollectionFilled } from '../../assets/fee_collection_filled.svg';
import { ReactComponent as FeeCollectionOutline } from '../../assets/fee_collection_outline.svg';
import { ReactComponent as FeeCollectionWhite } from '../../assets/fee_collection_white.svg';
import { ReactComponent as FeeReportsFilled } from '../../assets/fee_reports_filled.svg';
import { ReactComponent as FeeReportsOutline } from '../../assets/fee_reports_outline.svg';
import { ReactComponent as FeeReportsWhite } from '../../assets/fee_reports_white.svg';
import { ReactComponent as AcademicsFilled } from '../../assets/academics_filled.svg';
import { ReactComponent as AcademicsOutline } from '../../assets/academics_outline.svg';
import { ReactComponent as AcademicsWhite } from '../../assets/academics_white.svg';
import { ReactComponent as AnalyticsFilled } from '../../assets/analytics_filled.svg';
import { ReactComponent as AnalyticsOutline } from '../../assets/analytics_outline.svg';
import { ReactComponent as AnalyticsWhite } from '../../assets/analytics_white.svg';
import { ReactComponent as TransportFilled } from '../../assets/transport_filled.svg';
import { ReactComponent as TransportOutline } from '../../assets/transport_outline.svg';
import { ReactComponent as TransportWhite } from '../../assets/transport_white.svg';
import { ReactComponent as CaretRight } from '../../assets/caret_right.svg';
import { ReactComponent as CaretDown } from '../../assets/caret_down.svg';
import { ReactComponent as CaretDownWhite } from '../../assets/caret_down_white.svg';
import { ReactComponent as CaretLeft } from '../../assets/caret_left.svg';
import { ReactComponent as CaretRightWhite } from '../../assets/caret_right_white.svg';
import { ReactComponent as CaretLeftWhite } from '../../assets/caret_left_white.svg';
import { ReactComponent as Trash } from '../../assets/trash.svg';
import { ReactComponent as PlusWhite } from '../../assets/plus_white.svg';
import { ReactComponent as Plus } from '../../assets/plus.svg';
import { ReactComponent as CloseCircleFilled } from '../../assets/close_circle_filled.svg';
import { ReactComponent as PhoneCall } from '../../assets/phone-call.svg';
import { ReactComponent as EnvelopeSimple } from '../../assets/envelope-simple.svg';
import { ReactComponent as UserFilled } from '../../assets/user-fill.svg';
import { ReactComponent as UserFilledBlack } from '../../assets/user-fill-black.svg';
import { ReactComponent as UserFilledPurple } from '../../assets/user-fill-purple.svg';
import { ReactComponent as StudentBlack } from '../../assets/student_black.svg';
import { ReactComponent as ImageFillPrimary } from '../../assets/image-fill-primary.svg';
import { ReactComponent as FamilyBlack } from '../../assets/family_black.svg';
import { ReactComponent as FamilyWhite } from '../../assets/family_white.svg';
import { ReactComponent as FemalePurple } from '../../assets/female_purple.svg';
import { ReactComponent as FemaleBlack } from '../../assets/female_black.svg';
import { ReactComponent as MalePurple } from '../../assets/male_purple.svg';
import { ReactComponent as MaleBlack } from '../../assets/male_black.svg';
import { ReactComponent as ParentBlack } from '../../assets/parent_black.svg';
import { ReactComponent as ParentPurple } from '../../assets/parent_purple.svg';
import { ReactComponent as SiblingBlack } from '../../assets/sibling_black.svg';
import { ReactComponent as SiblingPurple } from '../../assets/sibling_purple.svg';
import { ReactComponent as PencilSimple } from '../../assets/pencil-simple.svg';
import { ReactComponent as CancelFilled } from '../../assets/cancel_filled.svg';
import { ReactComponent as PencilBold } from '../../assets/pencil_bold.svg';
import { ReactComponent as TrashWhite } from '../../assets/trash_white.svg';
import { ReactComponent as Cancel } from '../../assets/cancel.svg';
import { ReactComponent as RolloverOutlined } from '../../assets/rollover_outlined.svg';
import { ReactComponent as RolloverOutlinedBlack } from '../../assets/rollover_outlined_black.svg';
import { ReactComponent as NewAdmissionOutlined } from '../../assets/new_admission_outlined.svg';
import { ReactComponent as NewAdmissionOutlinedBlack } from '../../assets/new_admission_outlined_black.svg';
import { ReactComponent as StudentProfileFilled } from '../../assets/student_profile_filled.svg';
import { ReactComponent as StudentProfileBlackFilled } from '../../assets/student_profile_black_filled.svg';
import { ReactComponent as AcademicInfoFilled } from '../../assets/academic_info_filled.svg';
import { ReactComponent as DemographicInfoFilled } from '../../assets/demographic_info_filled.svg';
import { ReactComponent as HealthInfoFilled } from '../../assets/health_info_filled.svg';
import { ReactComponent as AcademicInfoBlackFilled } from '../../assets/academic_info_black_filled.svg';
import { ReactComponent as DemographicInfoBlackFilled } from '../../assets/demographic_info_black_filled.svg';
import { ReactComponent as HealthInfoBlackFilled } from '../../assets/health_info_black_filled.svg';
import { ReactComponent as PencilBoldOutlined } from '../../assets/pencil_bold_outlined.svg';
import { ReactComponent as SearchWhiteOutlined } from '../../assets/search_white_outlined.svg';
import { ReactComponent as AlertYellowFilled } from '../../assets/alert_yellow_filled.svg';
import { ReactComponent as PlusPurpleFilled } from '../../assets/plus_purple_filled.svg';
import { ReactComponent as EditBlackOutlined } from '../../assets/edit_black_outlined.svg';
import { ReactComponent as CardTickOutlined } from '../../assets/card-tick.svg';
import { ReactComponent as CardAddOutlined } from '../../assets/card-add.svg';
import { ReactComponent as CardSendOutlined } from '../../assets/card-send.svg';
import { ReactComponent as TransactionMinusOutlined } from '../../assets/transaction-minus.svg';
import { ReactComponent as CopySuccessOutlined } from '../../assets/copy-success.svg';
import { ReactComponent as GalleryOutlined } from '../../assets/gallery.svg';
import { ReactComponent as AddOutlined } from '../../assets/add.svg';
import { ReactComponent as MinusOutlined } from '../../assets/minus.svg';
import { ReactComponent as CardFilled } from '../../assets/card-fill.svg';
import { ReactComponent as CardBlack } from '../../assets/card-black.svg';
import { ReactComponent as ReceiptDiscountFilled } from '../../assets/receipt-discount-fill.svg';
import { ReactComponent as ReceiptDiscountBlack } from '../../assets/receipt-discount-black.svg';
import { ReactComponent as Warning } from '../../assets/warning.svg';
import { ReactComponent as Close } from '../../assets/close.svg';
import { ReactComponent as Check } from '../../assets/check.svg';
import { ReactComponent as ColumnsBlack } from '../../assets/coloums.svg';
import { ReactComponent as FilterBlack } from '../../assets/filter.svg';
import { ReactComponent as ImportBlack } from '../../assets/import.svg';
import { ReactComponent as SearchBlack } from '../../assets/search_black.svg';
import { ReactComponent as Unlink } from '../../assets/unlink.svg';
import { ReactComponent as Alert } from '../../assets/sos_alert.svg';
import { ReactComponent as Bus } from '../../assets/bus.svg';
import { ReactComponent as Copy } from '../../assets/copy.svg';
import { ReactComponent as AssignStudents } from '../../assets/assign_students.svg';
import { ReactComponent as DrivingBlack } from '../../assets/driving_black.svg';
import { ReactComponent as DrivingWhite } from '../../assets/driving_white.svg';
import { ReactComponent as RoutingBlack } from '../../assets/routing_black.svg';
import { ReactComponent as RoutingWhite } from '../../assets/routing_white.svg';
import { ReactComponent as Arrow3Black } from '../../assets/arrow-3_black.svg';
import { ReactComponent as Arrow3Filled } from '../../assets/arrow-3_filled.svg';
import { ReactComponent as ArrowDownBlack } from '../../assets/arrow-down_black.svg';
import { ReactComponent as ArrowDownFilled } from '../../assets/arrow-down_filled.svg';
import { ReactComponent as ArrowUpBlack } from '../../assets/arrow-up_black.svg';
import { ReactComponent as ArrowUpFilled } from '../../assets/arrow-up_filled.svg';
import { ReactComponent as Delete } from '../../assets/trash_bold.svg';
import { ReactComponent as BusAlert } from '../../assets/alert.svg';
import { ReactComponent as CalendarIcon } from '../../assets/calendar_icon.svg';
import { ReactComponent as UploadFile } from '../../assets/upload_file.svg';
import { ReactComponent as Eye } from '../../assets/eye.svg';
import { ReactComponent as Calendar } from '../../assets/calendar.svg';
import { ReactComponent as CloseWhiteFilled } from '../../assets/close_white_filled.svg';
import { ReactComponent as CancelPayment } from '../../assets/cancel_payment.svg';
import { ReactComponent as Send } from '../../assets/send.svg';
import { ReactComponent as Edit} from '../../assets/edit.svg';

import { FC, SVGProps } from 'react';

type SvgIconComponent = FC<SVGProps<SVGSVGElement>>;

// ✅ Explicit type allows dynamic indexing without TS error
const SvgIcons: Record<string, SvgIconComponent> = {
  Avatar,
  AvatarPhoto,
  Search,
  SuccessTick,
  ErrorCircle,
  AdminHomeFilled,
  AdminHomeOutline,
  AdminFilled,
  AdminOutline,
  StudentFilled,
  StudentOutline,
  FeeSetupFilled,
  FeeSetupOutline,
  FeeCollectionFilled,
  FeeCollectionOutline,
  FeeReportsFilled,
  FeeReportsOutline,
  AcademicsFilled,
  AcademicsOutline,
  AnalyticsFilled,
  AnalyticsOutline,
  TransportFilled,
  TransportOutline,
  CaretRight,
  CaretDown,
  CaretLeft,
  CaretRightWhite,
  CaretLeftWhite,
  AdminWhite,
  StudentWhite,
  FeeSetupWhite,
  FeeCollectionWhite,
  FeeReportsWhite,
  AcademicsWhite,
  AnalyticsWhite,
  TransportWhite,
  Trash,
  PlusWhite,
  Plus,
  CaretDownWhite,
  CloseCircleFilled,
  PhoneCall,
  EnvelopeSimple,
  UserFilled,
  UserFilledBlack,
  UserFilledPurple,
  StudentBlack,
  ImageFillPrimary,
  FamilyBlack,
  FamilyWhite,
  FemalePurple,
  FemaleBlack,
  MaleBlack,
  MalePurple,
  ParentBlack,
  ParentPurple,
  SiblingPurple,
  SiblingBlack,
  PencilSimple,
  CancelFilled,
  Cancel,
  RolloverOutlined,
  RolloverOutlinedBlack,
  NewAdmissionOutlined,
  NewAdmissionOutlinedBlack,
  PencilBold,
  TrashWhite,
  StudentProfileFilled,
  StudentProfileBlackFilled,
  AcademicInfoFilled,
  DemographicInfoFilled,
  HealthInfoFilled,
  AcademicInfoBlackFilled,
  DemographicInfoBlackFilled,
  HealthInfoBlackFilled,
  PencilBoldOutlined,
  SearchWhiteOutlined,
  AlertYellowFilled,
  PlusPurpleFilled,
  EditBlackOutlined,
  CardTickOutlined,
  CardAddOutlined,
  CardSendOutlined,
  TransactionMinusOutlined,
  CopySuccessOutlined,
  GalleryOutlined,
  AddOutlined,
  MinusOutlined,
  CardFilled,
  CardBlack,
  ReceiptDiscountFilled,
  ReceiptDiscountBlack,
  Warning,
  Close,
  Check,
  Unlink,
  Alert,
  Bus,
  Copy,
  AssignStudents,
  DrivingBlack,
  DrivingWhite,
  RoutingBlack,
  RoutingWhite,
  Arrow3Black,
  Arrow3Filled,
  ArrowDownBlack,
  ArrowDownFilled,
  ArrowUpBlack,
  ArrowUpFilled,
  Delete,
  BusAlert,
  CalendarIcon,
  UploadFile,
  Eye,
  CloseWhiteFilled,
  Calendar,
  CancelPayment,
  Send,
  ColumnsBlack,
  FilterBlack,
  ImportBlack,
  SearchBlack,
  Edit
};

export default SvgIcons;
